const BASE_URL = "";

async function apiFetch(path, options = {}) {
  const { getAuthToken } = await import("./authToken");
  const token = await getAuthToken();
  const headers = {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...options.headers,
  };

  const response = await fetch(`${BASE_URL}${path}`, {
    ...options,
    headers,
  });

  if (response.status === 401) {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    // Ne pas ejecter les pages publiques (tarifs/CGU) vers /login → / (forceRedirect)
    const path = window.location.pathname || "";
    const publicPaths = ["/pricing", "/cgu", "/confidentialite", "/login", "/register"];
    const isPublic = publicPaths.some(
      (p) => path === p || path.startsWith(`${p}/`)
    );
    if (!isPublic) {
      window.location.href = "/login";
    }
    throw new Error("Session expir\u00e9e");
  }

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.detail || data.message || "Une erreur est survenue");
  }

  return data;
}

const api = {
  get: (path) => apiFetch(path, { method: "GET" }),
  post: (path, body = {}) =>
    apiFetch(path, { method: "POST", body: JSON.stringify(body ?? {}) }),
  put: (path, body = {}) =>
    apiFetch(path, { method: "PUT", body: JSON.stringify(body ?? {}) }),
  patch: (path, body = {}) =>
    apiFetch(path, { method: "PATCH", body: JSON.stringify(body ?? {}) }),
  delete: (path) => apiFetch(path, { method: "DELETE" }),
};

export default api;
